export default "__VITE_ASSET__NA2AC$9d__"